module.exports = {
  menu: {
    1001: "管理",
    1002: "任务面板",
    1003: "项目",
    1004: "信息",
    1005: "账户",
    1006: "商业案例",
    1007: "状态",
    1008: "设置",
  },
  login: {
    1001: '登录',
    1002: '欢迎登录 XPROJECT',
    1003: '账号',
    1004: '请输入手机号',
    1005: '密码',
    1006: '请输入登录密码',
    1007: '记住登录密码',
    1008: '忘记密码？',
    1009: '忘记密码',
    1010: '邮箱',
    1011: '请输入邮箱',
    1012: '找回',
    1013: '确认密码',
    1014: '请输入密码',
    1015: '立即修改',
    1016: '请输入邮箱！',
    1017: '请输入密码！',
    1018: '请输入手机号！',
    1019: '验证码',
    1020: '请输入验证码',
    1021: '请输入确认密码',
  },
  home: {
    1001: "官网首页",
    1002: "您好",
    1003: "欢迎使用 爱察客｜ICHUK®项目管理系统",
    1004: "退出登录",
    1005: "中文",
    1006: "英文",
    1007: "2021 iChuk.com iChuk",
    1008: "苏ICP备12049303号-1",
    1009: "消息提醒",
    1010: "已过期",
    1011: "返回",
    1012: "管理平台",
  },
  management: {
    1001: "我的工作量",
    1002: "项目视图",
    1003: "任务视图",
    1004: "我的中心",
    1005: "项目中心",
    1006: "项目资源图",
    1007: "资源中心",
    1008: "控制面板",
    1009: "我的工作",
    1010: "我的任务面板",
    1011: "更多",
    1012: "我的项目",
    1013: "更多",
    1014: "查看更多",
    1015: "我的任务",
    1016: "更多",
    1017: "任务",
  },
  mypanel: {
    1001: '我的面板',
    1002: '姓名',
    1003: '电话',
    1004: '我的工作量',
    1005: 'TA的工作量',
    1006: 'TA的面板',
    1007: '工作量',
  },
  projectcenter: {
    1001: '投资组合',
    1002: '过程',
    // 1003: '清除',
    1004: '搜索',
    1005: '里程碑',
    1006: '关系图',
    1007: '资源信息',
    1008: '活跃',
    1009: '归档',
    1010: '保密',
    1011: '创建项目',
    1012: '项目名称',
    1013: '输入项目名称',
    1014: '选择投资组合',
    1015: '选择过程',
    1016: '说明',
    1017: '项目范围',
    1018: '生产线',
    1019: 'PPM项目编号',
    1020: 'PPM财务编号',
    1021: '招募成员',
    1022: '是',
    1023: '否',
  },
  taskpanel: {
    1001: '与我有关',
    1002: '创建任务面板',
  },
  resource: {
    1001: '分类',
    1002: '全部',
    1003: '权限',
  },
  button:{
    1001:'创建',
    1002:'视图',
    1003:'打印',
    1004:'下载',
    1005:'清除',
    1006:'取消',
    1007:'确认',
  }
}